import { ElementHelpers } from'../../helpers/element-helpers';

/**
 * Overall input class, used as base class for all input elements
 */
export class Input {

	/**
	 * @param {HTMLElement} elem - input element
	 * @param {HTMLElement} form - the form, the current element belongs to
	 * @constructor
	 */
	constructor(elem, form) {
		this.elem = elem;
		this.holder = ElementHelpers.getParentByClass(this.elem, 'form-group');
		if(!this.holder) return;
		this.form = form;
		this.hint = this.holder.querySelector('.form-group__hint');
		this.valid = null;

		this.eyeButton = this.holder.querySelector('.icon--eye');

		/** @type {Function} */
		this.inputCallback = null;
	}

	static get STATES() {
		return {
			DISABLED: 'form-group--disabled',
			ERROR: 'form-group--error',
			HAS_FOCUS: 'form-group--focus',
			DEFAULT: 'form-group',
			NO_CONTENT: 'form-group--no-content',
			VALID: 'form-group--valid',
			HAS_INPUT: 'form-group--has-input'
		}
	}

	get needValidation() {
		return this.form && this.form.elem && this.form.validationUrl && this.elem.hasAttribute('data-validate');
	}

	/**
	 * add all event handlers
	 *
	 * @returns {void}
	 */
	addEventHandlers() {
		this.elem.addEventListener('change', () => {
			if (this.needValidation) {
				this.validate();
			}
		});

		if(this.eyeButton){
			this.eyeButton.addEventListener('click', () => {
				this.togglePassword();
			})
		}

		this.elem.addEventListener('input', () => {
			this.handleInputText();

			// execute callback function, if set
			if (this.inputCallback && typeof this.inputCallback === 'function')
				this.inputCallback();
		});
	}


	validate() {
		this.form.validation.validateInput(this.elem).then((data) => {
			this.handleValidationResponse(data);
		});
	}

	handleValidationResponse(data) {
		const response = Object.keys(data);
		if (response.length) {
			this.setError(data[response].localizedMessage);
		} else {
			this.removeError();
		}
	}

	setError(message) {
		this.valid = false;
		const errorHolder = this.holder.querySelector('.form-group__errormsg');
		if (this.form.validation.errors.indexOf(this.elem.name) === -1) {
			this.form.validation.errors.push(this.elem.name);
		}
		this.holder.classList.add(Input.STATES.ERROR);
		this.holder.classList.remove(Input.STATES.VALID);
		if(!errorHolder){
			let errorMsg = document.createElement('span');
			errorMsg.classList.add('form-group__errormsg');
			errorMsg.innerHTML = message;
			if(this.hint) {
				this.hint.parentNode.insertBefore(errorMsg, this.hint);
			}else{
				this.holder.appendChild(errorMsg);
			}
		}
	}

	enableErrorState() {
		this.holder.classList.add(Input.STATES.ERROR);
		this.holder.classList.remove(Input.STATES.VALID);
	}

	disableErrorState() {
		this.holder.classList.add(Input.STATES.VALID);
		this.holder.classList.remove(Input.STATES.ERROR);
	}

	removeError() {
		this.valid = true;
		const errorHolder = this.holder.querySelector('.form-group__errormsg');
		const index = this.form.validation.errors.indexOf(this.elem.name);
		if (index > -1) {
			this.form.validation.errors.splice(index, 1);
		}
		this.disableErrorState();
		if (errorHolder) {
			ElementHelpers.removeElement(errorHolder);
		}
	}

	handleInputText(){
		if (this.elem.value !== '') {
			this.holder.classList.add(Input.STATES.HAS_INPUT);
			this.holder.classList.remove(Input.STATES.NO_CONTENT);
			this.holder.classList.remove(Input.STATES.ERROR);
		} else if (this.elem.value === '') {
			this.holder.classList.remove(Input.STATES.HAS_INPUT);
			this.holder.classList.add(Input.STATES.NO_CONTENT);
		}
	}

	/**
	 * Call this method with a callback to get updates on input changes
	 * @param callback {Function}
	 */
	subscribeToInputEvents(callback) {
		this.inputCallback = callback;
	}

	togglePassword() {
		if (this.elem.type === 'password') {
			this.elem.type = 'text';
		} else {
			this.elem.type = 'password';
		}
	}

}
